import React, { useCallback } from 'react';

import { useSharePanelStore } from 'src/common/store/share.store';
import { useFormikContext } from 'formik';
import { ShareLinkFormType } from '../../../link-config-form.factory';
import { ShareThumbnailFrameSliderOverlay } from './frame-slider.overlay';
import { ShareThumbnailConfirmationOverlay } from './upload-confirmation.overlay';

interface Props {
  onUploadClicked: () => void;
}

export const ShareThumbnailPickerOverlay = ({ onUploadClicked }: Props) => {
  const showThumbnailSlider = useSharePanelStore((state) => state.showThumbnailSlider);

  const { setFieldValue } = useFormikContext<ShareLinkFormType>();
  const onThumbnailUrlUpdate = useCallback((url: string) => setFieldValue('thumbnail_url', url), [setFieldValue]);

  return showThumbnailSlider ? (
    <ShareThumbnailFrameSliderOverlay onThumbnailUrlUpdate={onThumbnailUrlUpdate} />
  ) : (
    <ShareThumbnailConfirmationOverlay
      onThumbnailUrlUpdate={onThumbnailUrlUpdate}
      onChangeUploadedFileClicked={onUploadClicked}
    />
  );
};
